import { NAME } from './constants';

export default {
  FETCH: `${NAME}/FETCH`,
  FETCHED: `${NAME}/FETCHED`,
  FETCHING: `${NAME}/FETCHING`,
  CANCEL_FETCH: `${NAME}/CANCEL_FETCH`,
  REQUEST_ADDRESS_UPDATE: `${NAME}/REQUEST_ADDRESS_UPDATE`,
  BATCH_SALES_ORDERS: `${NAME}/BATCH_SALES_ORDERS`,
  BATCHED_SALES_ORDERS: `${NAME}/BATCHED_SALES_ORDERS`,
  GENERATE_REPORT: `${NAME}/GENERATE_REPORT`,
  GENERATED_REPORT: `${NAME}/GENERATED_REPORT`,
  TOGGLE_BATCHING_SCREEN: `${NAME}/TOGGLE_BATCHING_SCREEN`,
  BATCHED_SUCCESSFULLY: `${NAME}/BATCHED_SUCCESSFULLY`,
};
